import { createContext } from 'react'
import { NotificationModel } from '../../types/models/NotificationModel'

interface INotificationsContext {
  notifications: NotificationModel[]
  clearNotifications: () => void
  addNotification: (notification: NotificationModel) => void
  removeNotification: (id?: number) => void
}

const NotificationsContext = createContext<INotificationsContext>({
  notifications: [],
  clearNotifications: () => undefined,
  addNotification: (n) => undefined,
  removeNotification: (id) => undefined,
})

export default NotificationsContext
